<template>
  <section class="failed_enamad">
    <div class="alert alert-danger">
      <div class="h4">{{ $t('enamad_services.enamad_cancel_payment') }}</div>
    </div>
    <div class="row">
      <div class="col-md-12 mx-auto my-3 text-center">
        <button class="btn btn-success mx-1" @click="redirectToPayment">
          {{ $t('enamad_services.enamad_repayment') }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { BASE_PATH } from "@/common/config";
export default {
  name: "enamadFailed",
  props: ["shop_id"],
  methods: {
    redirectToPayment() {
      let userId = JSON.parse(localStorage.getItem("user"));
      const form = document.createElement("form");
      const input_shop_id = document.createElement("input");
      const input_user_id = document.createElement("input");
      form.action = BASE_PATH + "/gateway/enamad/pay";
      form.method = "GET";
      input_shop_id.type = "hidden";
      input_shop_id.name = "user_shop_id";
      input_shop_id.value = this.shop_id;
      input_user_id.type = "hidden";
      input_user_id.name = "user_id";
      input_user_id.value = userId.id;
      form.appendChild(input_user_id);
      form.appendChild(input_shop_id);
      document.body.appendChild(form);
      form.submit();
    },
  },
};
</script>
